export default __webpack_public_path__ + "static/media/license-icon.6705a493.svg";